// @mui material components
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDTypography from "components/MDTypography";

import { Component, createRef } from "react";
import { connect } from "react-redux";
import {
	ADD_POST_CAMPSITE_CHANNEL,
	ADD_POST_CAMPSITE_CITY_CHANNEL,
	DELETE_POST_CAMPSITE_CHANNEL,
	DELETE_POST_CAMPSITE_CITY_CHANNEL
} from "actions/types.js";
import {
	fetchSearchEventCampsiteChannels,
	fetchSearchEventCampsiteCityChannels
} from "actions/channel";
import { bindActionCreators } from "redux";
import ReactTags from "react-tag-autocomplete";

class Step6 extends Component {
	sendState() {
		return this.state;
	}

	handleDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_POST_CAMPSITE_CITY_CHANNEL,
				index
			});
		}
	};

	handleAddition = channel => {
		const { dispatch } = this.props;
		dispatch({
			type: ADD_POST_CAMPSITE_CITY_CHANNEL,
			value: channel
		});
	};

	handleChannelDelete = index => {
		const { dispatch } = this.props;

		if (index >= 0) {
			dispatch({
				type: DELETE_POST_CAMPSITE_CHANNEL,
				index
			});
		}
	};

	handleChannelAddition = channel => {
		const { dispatch } = this.props;
		dispatch({
			type: ADD_POST_CAMPSITE_CHANNEL,
			value: channel
		});
	};

	onInput = query => {
		if (query?.length > 2) {
			this.props.fetchSearchEventCampsiteCityChannels(query);
		}
	};

	onInputCommunities = query => {
		if (query?.length > 2) {
			this.props.fetchSearchEventCampsiteChannels(query);
		}
	};

	render() {
		const {
			ocamping_city_channels,
			ocamping_city_channels_suggestions,
			ocamping_channels,
			ocamping_channels_suggestions,
			publishedChannelErrorMsg
		} = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<MDTypography
						variant="h6"
						fontWeight="light"
						textAlign="center"
						mt={1.25}
						mb={1}
					>
						{
							"Veuillez sélectionner la/les villes, le/les campings où diffuser votre publication sur O’Camping"
						}
					</MDTypography>
				</Grid>
				<Grid item xs={12}>
					<ReactTags
						placeholderText="Villes ..."
						tags={ocamping_city_channels}
						suggestions={ocamping_city_channels_suggestions}
						minQueryLength={3}
						maxSuggestionsLength={10}
						onDelete={this.handleDelete}
						onAddition={this.handleAddition}
						suggestionsFilter={() => true}
						onInput={this.onInput}
						autoFocus={true}
						removeButtonText="Cliquez pour retirer"
						inputAttributes={{
							autoComplete: "new-password"
						}}
					/>
					{publishedChannelErrorMsg && (
						<FormHelperText error>{publishedChannelErrorMsg}</FormHelperText>
					)}
				</Grid>
				<Grid item xs={12} mt={2.5}>
					<ReactTags
						ref={this.tagsRef2}
						placeholderText="Campings ..."
						tags={ocamping_channels}
						suggestions={ocamping_channels_suggestions}
						minQueryLength={3}
						maxSuggestionsLength={10}
						onDelete={this.handleChannelDelete}
						onAddition={this.handleChannelAddition}
						suggestionsFilter={() => true}
						onInput={this.onInputCommunities}
						autoFocus={true}
						removeButtonText="Cliquez pour retirer"
						inputAttributes={{
							autoComplete: "new-password"
						}}
					/>
					{publishedChannelErrorMsg && (
						<FormHelperText error>{publishedChannelErrorMsg}</FormHelperText>
					)}
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		isFetching,
		publishedCities,
		publishedCityErrorMsg,
		suggestions,
		ocamping_city_channels,
		ocamping_city_channels_suggestions,
		ocamping_channels,
		ocamping_channels_suggestions,
		publishedChannelErrorMsg
	} = state.eventReducer;
	return {
		suggestions,
		publishedCities,
		publishedCityErrorMsg,
		isFetching,
		ocamping_city_channels: Object.values(ocamping_city_channels),
		ocamping_city_channels_suggestions: Object.values(
			ocamping_city_channels_suggestions
		),
		ocamping_channels: Object.values(ocamping_channels),
		ocamping_channels_suggestions: Object.values(ocamping_channels_suggestions),
		publishedChannelErrorMsg
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchSearchEventCampsiteCityChannels,
			fetchSearchEventCampsiteChannels
		},
		dispatch
	);
	return { ...actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step6);
